<template>
  <div>
    <TemplateLibraryGlobal v-if="!isEURegion" />
    <TemplateLibraryEU v-if="isEURegion" />
  </div>
</template>

<script>

import {
  mapState,
} from 'vuex'

import TemplateLibraryGlobal from '@/components-v2/template-library/TemplateLibraryGlobal'
import TemplateLibraryEU from '@/components-v2/template-library/TemplateLibraryEU'
import configs from '@/config'
import constants from '@/constant'

export default {
  components: {
    TemplateLibraryGlobal,
    TemplateLibraryEU,
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
    abTestGroup() {
      return this.currentUser && this.currentUser.id % 4
    },
    isEURegion() {
      return configs.region === constants.euRegion
    },
  },
}
</script>

<style lang="scss" scoped>
$thumbnail-ratio: calc(16 / 9);
$card-width: 250px;

@media (max-width: 768px) {
  .input-search-template {
    position: absolute;
    width: 190px;
    right: 0;
    top: 8px;
  }
}

.publish-presentation-btn {
  display: none;
  @media (min-width: 769px) {
    display: inline-flex;
  }
}

.slider {
  &.__slider {
    @apply relative;
    min-height: 220px;
  }

  &.__prev,
  &.__next {
    @apply absolute cursor-pointer bg-base-0 rounded-full w-10 h-10;
    @apply flex justify-center items-center hover:text-primary-100;
    top: 48%;
    z-index: 2;

    &.swiper-button-disabled {
      @apply hidden;
    }
    &.hidden {
      display: none;
    }
  }

  &.__prev {
    left: -20px;
    @media (max-width: 767px) {
      left: -12px;
    }
  }

  &.__next {
    right: -20px;
    @media (max-width: 767px) {
      right: -12px;
    }
  }
}

.swiper-slide {
  width: $card-width;
  padding-bottom: 0.25rem;
  margin-bottom: 1rem;
}

.template-library__content-wrapper {
  @apply relative flex flex-col h-full m-4 mt-6 md:px-6;
  .onboarding__arrow {
    @apply top-4 lg:-left-4 -left-8;
  }
}

</style>
